import React, { useState } from 'react';
import styled from 'styled-components/macro';
// import { lessonsSizes } from '@mirinae/lessons/modules/defines/styles';
// import { ancestorsFor } from '@mirinae/lessons/modules/libs/lessonLib';
import { UserAgent } from '@mirinae/js-utils';

import { apiPaths } from '@mirinae/shared/defines/paths';

const isMobile = !UserAgent.os.isOthers;

// this layout div implements the Figma constraints spec in CSS, requires the closest position-relative ancestor to match the
//  element's containing Figma lesson-page frame or page lesson-bounds rect and that it be a column flex container.
// const ElementLayoutByPos = styled.div`
//     ${(props) => {
//         const e = props.geomElement || props.element;
//         const { page } = ancestorsFor(e);
//         const lessonBounds = isMobile ? (page.mobile ? page.mobile.lessonBounds : { width: 370, height: 720 }) : (page.lessonBounds || page.geom || { width: 1440, height: 900 });
//         const [pageWidth, pageHeight] = [lessonBounds.width, lessonBounds.height];
//         const geom = isMobile && e.mobile ? e.mobile.geom : e.geom;
//         const constraints = isMobile && e.mobile ? e.mobile.constraints : e.constraints;
//         const size = e.size ? Number(e.size.split('%')[0]) / 100.0 : 1;
//         const [ratioX, ratioY] = [1, 1]; // content area now fixed, no need to scale relative to viewPort // [window.innerWidth / pageWidth, window.innerHeight / pageHeight];
//         const [ex, ey] = [geom.x - lessonBounds.x, geom.y - lessonBounds.y];
//         const [width, height] = props.domNode ? [props.domNode.clientWidth, props.domNode.clientHeight] : [geom.width, geom.height];
//         const [dCenterX, dCenterY] = [(ex + geom.width / 2) - pageWidth / 2, (ey + geom.height / 2) - pageHeight / 2];
//         const css = ['position: absolute'];
//         if (constraints.horizontal === 'CENTER') {
//             // css.push(`left: calc(50vw + ${ratioX * dCenterX - width / 2}px);`);  // lesson content area now fixed. no need to scale relative to viewport
//             css.push(`left: ${pageWidth / 2 + ratioX * dCenterX - width / 2}px;`);
//         }
//         if (constraints.horizontal.match(/MIN|STRETCH/)) {
//             css.push(`left: ${ex}px`);
//         }
//         if (constraints.horizontal.match(/MAX|STRETCH/)) {
//             css.push(`right: ${window.innerWidth - window.scrollX - (ex + width)}px`);
//         }
//         if (constraints.vertical === 'CENTER') {
//             // css.push(`top: calc(50vh + ${ratioY * dCenterY - height / 2}px);`);  // lesson content area now fixed. no need to scale relative to viewport
//             css.push(`top: ${pageHeight / 2 + ratioY * dCenterY - height / 2}px;`);
//         }
//         if (constraints.vertical.match(/MIN|STRETCH/)) {
//             css.push(`top: ${ey}px`);
//         }
//         if (constraints.vertical.match(/MAX|STRETCH/)) {
//             css.push(`bottom: ${window.innerHeight - window.scrollY - (ey + height)}px`);
//         }
//         css.push(`transform: scale(${size})`);
//         css.push(`width: ${(geom.width * 0.903225806451613) / size}px`);
//         css.push(`height: ${geom.height / size}px`);
//         return css.join(';');
//     }};
// `;

const ElementLayout = styled.div`
    display: flex;
    justify-content: center;
    margin-top: ${props => props.margin.top}px;
    margin-left: ${props => props.margin.left}px;
    width: ${props => (isMobile ? '100%' : `${props.geom.width / props.size}px`)};
    min-height: ${props => (props.geom.height / props.size)}px;
    ${isMobile && `
        svg {
            max-width: ${window.innerWidth - 40}px;
            @media only screen and (orientation: landscape) {
                max-width: ${window.innerHeight - 40}px;
            }
        }
    `}
`;

// this base component must be specialized by all element-rendering components in order
// to ensure they honor the Figma layout constraints set during lesson editing.  These are set  by the ElementLayout wrapper above.
const Element = (props) => {
    const [domNode, setDomNode] = useState(null);
    const geomElement = props.geomElement || props.element;
    const geom = isMobile && geomElement.mobile ? geomElement.mobile.geom : geomElement.geom;
    const margin = geomElement.layout.margin;
    return (
        <ElementLayout
            className={`el-${props.element.componentName}`} {...props} size={1}
            domNode={domNode} ref={setDomNode} geom={geom} margin={margin}
        >
            {props.children}
        </ElementLayout>
    );
};

const MissingElementWrapper = styled(Element)`
    display: none;
    // width: ${props => (isMobile && props.element.mobile ? props.element.mobile.geom.width : props.element.geom.width)}px;
    // height: ${props => (isMobile && props.element.mobile ? props.element.mobile.geom.height : props.element.geom.height)}px;
    // align-items: center;
    // justify-content: center;
`;
// const MissingElementImg = styled.img`
//     content: url(${props => `${apiPaths.elementImage}/${props.element.figmaKey}`});
// `;
export const MissingElement = (props) => (
    <MissingElementWrapper {...props}>
        <img {...props} src={`${apiPaths.elementImage}/${props.element.figmaKey}`} alt="" />
    </MissingElementWrapper>
);

export default Element;
